webpackJsonp([70144966829960],{

/***/ 120:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.hoistNonReactStatics = factory());
	}(this, (function () {
	    'use strict';
	    
	    var REACT_STATICS = {
	        childContextTypes: true,
	        contextTypes: true,
	        defaultProps: true,
	        displayName: true,
	        getDefaultProps: true,
	        getDerivedStateFromProps: true,
	        mixins: true,
	        propTypes: true,
	        type: true
	    };
	    
	    var KNOWN_STATICS = {
	        name: true,
	        length: true,
	        prototype: true,
	        caller: true,
	        callee: true,
	        arguments: true,
	        arity: true
	    };
	    
	    var defineProperty = Object.defineProperty;
	    var getOwnPropertyNames = Object.getOwnPropertyNames;
	    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	    var getPrototypeOf = Object.getPrototypeOf;
	    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	    
	    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	            
	            if (objectPrototype) {
	                var inheritedComponent = getPrototypeOf(sourceComponent);
	                if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	                }
	            }
	            
	            var keys = getOwnPropertyNames(sourceComponent);
	            
	            if (getOwnPropertySymbols) {
	                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	            }
	            
	            for (var i = 0; i < keys.length; ++i) {
	                var key = keys[i];
	                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                    try { // Avoid failures from read-only properties
	                        defineProperty(targetComponent, key, descriptor);
	                    } catch (e) {}
	                }
	            }
	            
	            return targetComponent;
	        }
	        
	        return targetComponent;
	    };
	})));


/***/ }),

/***/ 255:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(72);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _contactModule = __webpack_require__(351);
	
	var _contactModule2 = _interopRequireDefault(_contactModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Contact = function (_Component) {
	  _inherits(Contact, _Component);
	
	  function Contact() {
	    _classCallCheck(this, Contact);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Contact.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      {
	        className: _contactModule2.default.contact
	      },
	      _react2.default.createElement(
	        'form',
	        {
	          action: '/',
	          className: _contactModule2.default.contactForm,
	          name: 'contact',
	          method: 'POST',
	          'data-netlify': true
	        },
	        _react2.default.createElement('input', { type: 'hidden', name: 'form-name', value: 'contact' }),
	        _react2.default.createElement(
	          'label',
	          {
	            className: _contactModule2.default.label,
	            htmlFor: ''
	          },
	          'Name'
	        ),
	        _react2.default.createElement('input', {
	          className: _contactModule2.default.formInput,
	          name: 'name',
	          placeholder: 'name',
	          type: 'text'
	        }),
	        _react2.default.createElement(
	          'label',
	          {
	            className: _contactModule2.default.label,
	            htmlFor: ''
	          },
	          'Email'
	        ),
	        _react2.default.createElement('input', {
	          className: _contactModule2.default.formInput,
	          name: 'email',
	          placeholder: 'email',
	          type: 'text'
	        }),
	        _react2.default.createElement(
	          'label',
	          {
	            className: _contactModule2.default.label,
	            htmlFor: ''
	          },
	          'Message'
	        ),
	        _react2.default.createElement('textarea', {
	          className: _contactModule2.default.formInput,
	          name: 'message',
	          id: '',
	          cols: '30',
	          placeholder: 'message',
	          rows: '6'
	        }),
	        _react2.default.createElement('input', {
	          className: _contactModule2.default.formInput,
	          type: 'submit', value: 'submit'
	        })
	      ),
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        {
	          className: _contactModule2.default.back,
	          to: '/'
	        },
	        '<-- back'
	      )
	    );
	  };
	
	  return Contact;
	}(_react.Component);
	
	exports.default = Contact;
	module.exports = exports['default'];

/***/ }),

/***/ 351:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"contact":"src-pages----contact-module---contact---3yNwE","contactForm":"src-pages----contact-module---contactForm---1o6S7","back":"src-pages----contact-module---back---2OJLR","formInput":"src-pages----contact-module---formInput---2hfyc","label":"src-pages----contact-module---label---CYDel"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-js-91927c2e49384b4a9e50.js